import {
  Box,
  Typography,
  IconButton,
  ButtonBase,
  Menu,
  MenuItem,
} from "@mui/material";
import { getAuthUserId } from "../../../utils/auth.util";
import { useEffect, useState } from "react";
import messagesService from "../../../services/messages.service";
import { useAppDispatch } from "../../../store/appHooks";
import {
  setConversation,
  setConversations,
} from "../../../slices/messagesReducer";
import { CustomPlainTextField } from "../../mui-common/CustomPlainTextField";
import SearchIcon from "@mui/icons-material/Search";
import ChatRoomItem from "./chat-room-item";
import { Close } from "@mui/icons-material";
import SearchSection from "components/my-listing/search-input";
import useQuery from "utils/router.util";

const ChatRooms = ({
  list,
  convId,
}: {
  list: Array<any>;
  convId: string | null;
}) => {
  const [rooms, setRooms] = useState(list);
  const [search, setSearch] = useState("");
  const loggedInAuthId = getAuthUserId();
  const query = useQuery();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getDisplayName = (row: any) => {
    if (convId === "new" && row?.isNew) {
      return query.get("user") || "undefined";
    }
    const diffParticipants = row?.participants?.filter(
      (c: any) => c !== loggedInAuthId
    );
    return row?.users?.[diffParticipants] ?? "";
  };

  useEffect(() => {
    setRooms(
      list.filter((c: any) =>
        getDisplayName(c).toLowerCase().includes(search.trim())
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, list]);

  const handleReadSorting = () => {
    setRooms(
      list.filter(
        (c: any) =>
          !(c?.messagedBy !== loggedInAuthId && c?.lastMessageCount > 0)
      )
    );
    handleClose();
  };

  const handleUnReadSorting = () => {
    setRooms(
      list.filter(
        (c: any) => c?.messagedBy !== loggedInAuthId && c?.lastMessageCount > 0
      )
    );
    handleClose();
  };

  const handleAllSorting = () => {
    setRooms(list);
    handleClose();
  };

  return (
    <Box
      sx={{
        borderRight: "1px solid #E2E2E2",
        // minHeight: "60vh",
        // height: "72vh",
        background: "#FFF",
      }}
    >
      <Box
        sx={{
          pl: { md: "11.5%", lg: "11.5%", xl: "11.5%", sm: "3%", xs: "3%" },
          py: "20px",
          pr: "4%",
          display: "flex",
          gap: "10px",
        }}
      >
        <SearchSection
          placeholder="Search or start new chat"
          onChange={({ target }: any) => setSearch(target.value)}
        />
        <ButtonBase
          sx={{
            border: "1px solid #E2E2E2",
            height: "48px",
            width: "48px",
            borderRadius: "10px",
          }}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <img src="/assets/img/icons/sort.svg" alt="" />
        </ButtonBase>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleAllSorting}>All</MenuItem>
          <MenuItem onClick={handleReadSorting}>Read</MenuItem>
          <MenuItem onClick={handleUnReadSorting}>Unread</MenuItem>
        </Menu>
      </Box>
      <Box
        sx={{
          height: {
            md: "58vh",
            lg: "58vh",
            xl: "58vh",
            sm: "59vh",
            xs: "59vh",
          },
        }}
        overflow="auto"
        className="small-scroll"
      >
        {rooms.length === 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
            flexDirection="column"
            gap="15px"
          >
            <img src="/assets/img/no-messages.png" alt="" width="230px" />
            <Typography color="gray">No chat available</Typography>
          </Box>
        )}
        {rooms.map((c, i) => (
          <Box
            sx={{
              pl: { md: "11.5%", lg: "11.5%", xl: "11.5%", sm: "3%", xs: "3%" },
              background: convId === c.id ? "#E1FFA2" : "#FFF",
              borderRight:
                convId === c.id ? "4px solid #6E8C20" : "4px solid #FFF",
            }}
          >
            <ChatRoomItem
              c={c}
              key={c.id}
              convId={convId ?? ""}
              getDisplayName={getDisplayName}
            />
          </Box>
        ))}
        {rooms.length > 0 && <Box sx={{ height: "50px", width: "100%" }} />}
      </Box>
    </Box>
  );
};

export default ChatRooms;
